import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { GenericMedia } from '@/declarations/GenericMedia';
import { DamsMediaItem } from '@/declarations/models/DamsMediaResponse';
import Container from '../../Container';
import SelectedMediaItemContainer from '../SelectedMediaItemContainer';

export interface SelectedDamsItemProps {
  item: GenericMedia<DamsMediaItem>;
  onRemoveItem: (item: GenericMedia<DamsMediaItem>) => void;
}

export const SelectedDamsItem: FC<SelectedDamsItemProps> = ({ item, onRemoveItem }) => {
  return (
    <SelectedMediaItemContainer item={item} onRemoveItem={onRemoveItem}>
      <Container column spaceBetween left fullWidth fullHeight>
        <Typography sx={{ wordBreak: 'break-word', fontWeight: 'bold' }}>{item.title}</Typography>
      </Container>
    </SelectedMediaItemContainer>
  );
};

export default SelectedDamsItem;
